/**
 * Created by baladewa on 5/20/16.
 */
'use strict';
(function () {
    angular
        .module('commons')
        .component('managePairingComponent', {
            templateUrl: 'manage-pairing/components/manage-pairing-component.tpl.html',
            controller: function ($element, EventManagerService, ContextMenuService, $timeout, ManagePairing,MessageService) {
                var vm = this, min_screen_width=1200, selectedBlockForContextMenu;
                vm.isElasticLoadingVisible = false;
                vm.myKey = null;
                vm.model = {
                    pairingData :[],
                    filteredData:{}
                };
                vm.timeLineData = [];
                vm.groupLineData = [];
                vm.screen_left_panel = 0;
                vm.actual_screen_width = window.innerWidth;

                if (!!vm.actual_screen_width && vm.actual_screen_width > min_screen_width) {
                    vm.screen_right_panel = vm.actual_screen_width - vm.screen_left_panel;
                }

                EventManagerService.registerEventListener(EventManagerService.EVENT.SHOW_HIDE_LOADING, showHideElasticLoading);
                EventManagerService.registerEventListener(EventManagerService.EVENT.MANAGE_PAIRING.DATA_CHANGE, searchPairings);
                EventManagerService.registerEventListener(EventManagerService.EVENT.MANAGE_PAIRING.APPEND_PAIRING_DATA, searchPairingForAppend);
                EventManagerService.registerEventListener(EventManagerService.EVENT.MANAGE_PAIRING.UPDATE_PAIRING_DATA, updatePairings);

                vm.$onChanges = function (changeObj) {
                    if (changeObj.selectedPair && changeObj.selectedPair.currentValue && (changeObj.selectedPair.currentValue != changeObj.selectedPair.previousValue)) {
                        renderTimeLine();
                    }
                    if (changeObj.pairingData && changeObj.pairingData.currentValue && (changeObj.pairingData.currentValue != changeObj.pairingData.previousValue)) {
                        searchPairings();
                    }
                };

                vm.clickOnBlock = function(event, pair){
                    var option = {
                        event:event, selectedPair:pair
                    };
                    vm.selectAPair(option);
                    event.stopPropagation();
                };

                vm.dblOnBlock = function(event, pair){
                    var option = {
                        event:event, selectedPair:pair
                    };
                    vm.dblClickAPair(option);
                };

                vm.clickOnRow = function(event, pair){
                    var option = {
                        event:event, selectedPair:pair
                    };
                    vm.selectAPair(option);
                };

                vm.getPatternMenu = function(type, block){
                    selectedBlockForContextMenu = block;
                    return ContextMenuService.getContextMenu(type);
                };

                vm.pressedKey = function(event){
                  if(event.key === "Delete") {
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.CONTEXT_MENU.DELETE_BLOCK);
                  }
                };


                function showHideElasticLoading(data){
                    if (data.target == 'managePairing') {
                        vm.isElasticLoadingVisible = data.flag;
                        if (data.flag && angular.element('.elasticLoadingOverlay').length == 0) {
                        	var overlay = angular.element('<div class="elasticLoadingOverlay"></div>');
                        	overlay.css({
                        	    'background-color': '#eee',
                        	    'opacity': '0.8',
                        	    'position': 'absolute',
                        	    'left': '0px',
                        	    'top': '0px',
                        	    'z-index': '1100',
                        	    'height': '100%',
                        	    'width': '100%',
                        	    'overflow': 'hidden',
                        	    'background-image': "url('ajax-loader.gif')",
                        	    'background-position': 'center',
                        	    'background-repeat': 'no-repeat',
                        	    });
                        	angular.element(document.body).append(overlay);
                        	angular.element('.right-section').css('overflow', 'hidden');
                    	} else if (data.flag) {
                    	    angular.element('.elasticLoadingOverlay').removeClass('ng-hide');
                    	    angular.element('.right-section').css('overflow', 'hidden');
                    	} else {
                    	    angular.element('.elasticLoadingOverlay').addClass('ng-hide');
                    	    angular.element('.right-section').css('overflow', 'auto');
                    	}
                    }
                }

                function searchPairings(){
                    var pairedData = ManagePairing.getPairingsList();
                    vm.model.pairingData = pairedData;
                    vm.model.filteredData = getFilteredData(pairedData);
                }

                function searchPairingForAppend(pairedData){
                    if(pairedData.length!==0){
                        filterDataForDate(pairedData);
                    }
                }

                function updatePairings(deletedList){
                    angular.forEach(deletedList, function(deletedItem){
                        var deletedArrayKey = deletedItem.startDate;
                        var deletedArray = vm.model.filteredData[deletedArrayKey];
                        for (var i=0;i<deletedArray.length;i++){
                            var pairing = deletedArray[i];
                            if(deletedItem.patternId === pairing.patternId){
                                deletedArray.splice(i,1);
                                break;
                            }
                        }
                    });
                }

                function getFilteredData(dataToFilter){
                    return _.groupBy(dataToFilter, 'startDate');
                }

                function filterDataForDate(dataToFilter){
                    var groupedData = _.groupBy(dataToFilter, 'startDate');
                    angular.forEach(groupedData, function(group, key){
                        var keyGroup = vm.model.filteredData[key] || [];
                        angular.forEach(group, function(item){
                            keyGroup.push(item);
                        });
                        vm.model.filteredData[key] = keyGroup;
                    });
                }

                function setPatternMeasurements(patternGroup) {
                    angular.forEach(patternGroup.groupItems, function(pattern){
                        var tmpPatternEndInPx;
                        var mo_pattern_start = moment(vm.fromDate + ' ' + '00:00', 'DD/MM/YYYY HH:mm');
                        pattern.leftPos = getTimeInMinFromStartDate(pattern.startDate, pattern.startTime, mo_pattern_start);
                        tmpPatternEndInPx = getTimeInMinFromStartDate(pattern.endDate, pattern.endTime, mo_pattern_start);
                        pattern.widthInPx = (tmpPatternEndInPx - pattern.leftPos);
                        pattern.blockList = _.each(pattern.blockList, function(block){
                            var tmpBlockEndTimeInPx;
                            var mo_block_start = moment(pattern.startDate + ' ' + pattern.startTime, 'DD/MM/YYYY HH:mm');
                            block.leftPos = getTimeInMinFromStartDate(block.blockStartDate, block.blockStartTime, mo_block_start);
                            tmpBlockEndTimeInPx = getTimeInMinFromStartDate(block.blockDetailEndDate, block.blockDetailEndTime, mo_block_start);
                            block.widthInPx = (tmpBlockEndTimeInPx - block.leftPos);
                            block.blockDetailList = _.each(block.blockDetailList, function(blockDetail){
                                var tmpBlockDetailEndTimeInPx;
                                var mo_block_detail_start = moment(block.blockStartDate + ' ' + block.blockStartTime, 'DD/MM/YYYY HH:mm');
                                blockDetail.leftPos = getTimeInMinFromStartDate(blockDetail.departureDate, blockDetail.departureTime, mo_block_detail_start);
                                tmpBlockDetailEndTimeInPx = getTimeInMinFromStartDate(blockDetail.arrivalDate, blockDetail.arrivalTime, mo_block_detail_start);
                                blockDetail.widthInPx = (tmpBlockDetailEndTimeInPx - blockDetail.leftPos);
                            })
                        });
                    });
                    return patternGroup;
                }

                function renderTimeLine(){

                }
            },
            bindings: {
                selectedPair:'<',
                pairingData:'<',
                dateFormat: '@',
                selectAPair: '&',
                dblClickAPair: '&'
            }
        })
})();
